/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Grid, Typography, TextField, Box, IconButton } from "@mui/material";
import { useStyles } from "./termSheet.style";

import InfoIcon from "./assets/InfoIconBlack.svg";
import NewEditIcon from "./assets/NewEditIcon.svg";

const TermSheetFooter = (props) => {
  const {
    isSignatureRequired = false,
    termSheetConfig,
    isDownloadingTermSheet
  } = props;
  const DefaultSignature = termSheetConfig?.footer?.DefaultSignature;
  const classes = useStyles();

  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const [signatureData, setSignatureData] = useState(
    termSheetConfig?.signatureData
  );
  const handleSave = termSheetConfig?.handleSignatureSave;
  const isEditsEnable = termSheetConfig?.isEditsEnable;

  useEffect(() => {
    const email = termSheetConfig?.signatureInfo?.email;
    const name = termSheetConfig?.signatureInfo?.name;
    const accountName = termSheetConfig?.signatureInfo?.accountName;
    const phone = termSheetConfig?.signatureInfo?.phone;
    setSignatureData({ email, name, accountName, phone });
  }, [
    termSheetConfig?.signatureInfo?.accountName,
    termSheetConfig?.signatureInfo?.email,
    termSheetConfig?.signatureInfo?.name,
    termSheetConfig?.signatureInfo?.phone
  ]);

  const formatPhoneNumber = (value) => {
    return  value.replace(/[^0-9+,-]/g, '') // Allow only digits, +, and -
    .replace(/^(?=\+)([^\d]*|\d{0,2})?(\d{0,4})?(\d{0,3})?(\d{0,3})?/, (match, p1, p2, p3, p4) => {
        return `${p1 || ''}${p2 || ''}${p3 ? '-' + p3 : ''}${p4 ? '-' + p4 : ''}`.trim();
    })
  }

  const handleEdit = (key, value) => {
    const tempObj = { ...signatureData };
    // tempObj[key] = value;
    if(key === 'phone') {
      // tempObj[key] = value.replace(/[^0-9]/g, '')
      tempObj[key] = formatPhoneNumber(value)
    } else {
      tempObj[key] = value;
    }

    setSignatureData({ ...signatureData, [key]: value });
  };

  const handleBlur = (key, value) => {
    const tempObj = { ...termSheetConfig?.signatureInfo };
    if(key === 'phone') {
      // tempObj[key] = value.replace(/[^0-9]/g, '')
      tempObj[key] = formatPhoneNumber(value)
    } else {
      tempObj[key] = value;
    }
    // tempObj[key] = value;
    handleSave(tempObj);
  };

  return (
    <Grid className={classes.footerContainer}>
      <Typography style={{ display: "grid" }}>Best regards,</Typography>
      {isEditsEnable?.isFooterEditable && !isDownloadingTermSheet ? (
        <Grid container>
          <Box
            sx={{
              border: "1px solid #e1e8ee",
              display: "grid",
              width: "44%",
              paddingLeft: "8px"
            }}
          >
            {isEditEnabled ? (
              <Grid item xs={11}>
                <Grid item xs={12} sx={{ marginTop: "16px" }}>
                  <TextField
                    size='small'
                    onChange={(e) => {
                      return handleEdit("name", e.target.value);
                    }}
                    fullWidth
                    value={signatureData?.name}
                    onBlur={(e) => {
                      return handleBlur("name", e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sx={{ marginTop: "16px" }}>
                  <TextField
                    size='small'
                    onChange={(e) => {
                      return handleEdit("email", e.target.value);
                    }}
                    onBlur={(e) => {
                      return handleBlur("email", e.target.value);
                    }}
                    fullWidth
                    value={signatureData?.email}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ marginTop: "16px", marginBottom: "16px" }}
                >
                  <TextField
                    size='small'
                    onChange={(e) => {
                      return handleEdit("accountName", e.target.value);
                    }}
                    onBlur={(e) => {
                      return handleBlur("accountName", e.target.value);
                    }}
                    fullWidth
                    value={signatureData?.accountName}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ marginTop: "16px", marginBottom: "16px" }}
                >
                  <TextField
                    size='small'
                    onChange={(e) => {
                      return handleEdit("phone", e.target.value);
                    }}
                    onBlur={(e) => {
                      return handleBlur("phone", e.target.value);
                    }}
                    fullWidth
                    value={signatureData?.phone}
                    placeholder='Phone Number'
                    type='text'
                  />
                </Grid>
              </Grid>
            ) : (
              <>
                <Grid
                  container
                  style={{
                    fontSize: "16px",
                    marginTop: "16px",
                    color: "#3c3c3c",
                    fontWeight: 600
                  }}
                >
                  <span>{signatureData?.name}</span>
                </Grid>
                <Grid
                  container
                  style={{
                    fontSize: "12px",
                    marginTop: "4px",
                    color: "#3c3c3c"
                  }}
                >
                  <span>{signatureData?.email}</span>
                </Grid>
                <Grid
                  container
                  style={{
                    fontSize: "12px",
                    marginTop: "4px",
                    color: "#3c3c3c"
                  }}
                >
                  <span>{signatureData?.accountName}</span>
                </Grid>
                {signatureData?.phone ? (
                  <Grid
                    container
                    style={{
                      fontSize: "12px",
                      marginTop: "4px",
                      marginBottom: "16px",
                      color: "#3c3c3c"
                    }}
                  >
                    <span>{signatureData?.phone}</span>
                  </Grid>
                ) : null}
              </>
            )}
          </Box>
          <Grid item={6} sx={{ marginLeft: "8px" }}>
            {!isEditEnabled ? (
              <IconButton
                onClick={() => {
                  return setIsEditEnabled(true);
                }}
              >
                <img src={NewEditIcon} alt='edit' />
              </IconButton>
            ) : null}
          </Grid>
        </Grid>
      ) : (
        <Typography style={{ display: "grid" }}>
          <span
            style={{
              fontSize: "16px",
              marginTop: "16px",
              color: "#3c3c3c",
              fontWeight: 600
            }}
          >
            {signatureData?.name}
          </span>
          <span
            style={{
              fontSize: "12px",
              marginTop: "4px",
              color: "#3c3c3c"
            }}
          >
            {signatureData?.email}
          </span>
          <span
            style={{
              fontSize: "12px",
              marginTop: "4px",
              color: "#3c3c3c"
            }}
          >
            {signatureData?.accountName}
          </span>
          {signatureData?.phone ? (
            <span
              style={{
                fontSize: "12px",
                marginTop: "4px",
                marginBottom: "16px",
                color: "#3c3c3c"
              }}
            >
              {signatureData?.phone}
            </span>
          ) : null}
        </Typography>
      )}
      {/* <span style={{ fontSize: "10px" }}>
          {getRole(profileData?.roles[0])}
        </span> */}
      {isSignatureRequired && termSheetConfig?.footer?.DefaultSignature && (
        <DefaultSignature
          email={signatureData?.email}
          name={signatureData?.name}
        />
      )}
      <div
        style={{
          fontSize: "12px",
          marginTop: "4px",
          backgroundColor: "#f6f9fc",
          padding: "4px",
          marginBottom: "8px",
          borderRadius: "8px"
        }}
      >
        <img
          src={InfoIcon}
          alt='info_icon'
          style={{ position: "relative", top: "4px", paddingRight: "8px" }}
        />
        <span>
          All loan metrics stated above are subject to full underwriting review
          and approval of the documentation required to support the data points.
        </span>
      </div>
    </Grid>
  );
};

export default React.memo(TermSheetFooter);
